import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import PrinterSelect from "@/components/PrinterSelect";
import { FormInstance } from "antd";
import PurchasingLabelTemplateSelect, { DEFAULT_PURCHASING_LABEL_TEMPLATE } from "./PurchasingLabelTemplateSelect";
import { PurchasingLabelTemplateDTO } from "@/dto/template/PurchasingLabelTemplateDTO";

interface PrintPurchasingLabelFormProps {
    form: FormInstance<PrintPurchasingLabelFormValues>;
    onPurchasingLabelTemplatesLoad: (templates: PurchasingLabelTemplateDTO[]) => void;
}

export interface PrintPurchasingLabelFormValues {
    templateId: number;
    printer: string;
}

const PrintPurchasingLabelForm: React.FC<PrintPurchasingLabelFormProps> = function (props, ref) {
    const { form, onPurchasingLabelTemplatesLoad } = props;
    const [purchasingLabelTemplates, setPurchasingLabelTemplates] = useState<PurchasingLabelTemplateDTO[]>();
    const [templateId, setTemplateId] = useState<number>();
    function handleSetDefaultOrderItemLabelTemplate() {
        if (!templateId) {
            return Modal.error({
                title: "当前没有拿货标签模板，请先添加",
            });
        }

        const template = purchasingLabelTemplates?.find((it) => it.id === templateId);

        if (template) {
            localStorage.setItem(DEFAULT_PURCHASING_LABEL_TEMPLATE, String(templateId));

            Modal.success({
                title: `设置成功，默认拿货标签模板为：${template.name}`,
            });
        }
    }

    useEffect(() => {
        if (templateId) {
            const template = purchasingLabelTemplates?.find((it) => it.id === templateId);
            const printer = template?.bindingPrinter;

            if (printer) {
                form.setFieldsValue({
                    printer,
                });
            }
        }
    }, [templateId, purchasingLabelTemplates]);

    useEffect(() => {
        onPurchasingLabelTemplatesLoad(purchasingLabelTemplates);
    }, [purchasingLabelTemplates]);

    const help =
        purchasingLabelTemplates?.length === 0 ? (
            <span className="error small">
                暂无拿货标签模板请先
                <a href="/features/purchasingLabel?tab=purchasingLabelEdit" target="_blank">
                    点击这里添加模板
                </a>
            </span>
        ) : undefined;

    return (
        <Form layout="inline" form={form}>
            <Form.Item
                label="拿货标签模板"
                name="templateId"
                style={{ marginBottom: "20px" }}
                rules={[{ required: true, message: "请选择拿货标签模板" }]}
                help={help}
            >
                <PurchasingLabelTemplateSelect
                    style={{ width: 220 }}
                    onLoad={setPurchasingLabelTemplates}
                    onChange={setTemplateId}
                />
            </Form.Item>

            <Button type="link" onClick={handleSetDefaultOrderItemLabelTemplate}>
                设为默认模板
            </Button>

            <Form.Item
                label="打印机"
                name="printer"
                className="ml40"
                rules={[{ required: true, message: "请选择打印机" }]}
            >
                <PrinterSelect style={{ width: 220 }} />
            </Form.Item>
        </Form>
    );
};

export default React.memo(PrintPurchasingLabelForm);
